export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/decc719ac0c1523cc2040d71b927dcbc.svg";